/**
 * Recognises a lazy-route chunk that failed to load (#1491). Each engine words
 * the rejected dynamic `import()` differently, and Vite adds its own CSS
 * preload failure; all of them mean "this bundle's code couldn't be fetched",
 * which a reload (onto fresh assets) fixes and a re-render never will — React
 * caches the rejected `lazy()` promise.
 */
const CHUNK_LOAD_PATTERNS: readonly RegExp[] = [
  /Failed to fetch dynamically imported module/i, // Chromium
  /Importing a module script failed/i, // WebKit
  /error loading dynamically imported module/i, // Gecko
  /Unable to preload CSS/i, // Vite preload helper
];

export const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  if (error.name === "ChunkLoadError") return true;
  return CHUNK_LOAD_PATTERNS.some((pattern) => pattern.test(error.message));
};
